import { render } from "./header_main.vue?vue&type=template&id=315b160b"
import script from "./header_main.vue?vue&type=script&lang=js"
export * from "./header_main.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Server\\Document\\live-class-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__